import { QuoteFile } from '@frontend/api';

import { isFileVector } from 'utils/helpers';

type createTemporaryQuoteItemProps = {
  lineItemPosition: number;
  newTempQuoteItems: unknown[];
  oldQuoteItems: unknown[];
};

export const createTemporaryQuoteItems = ({
  lineItemPosition,
  newTempQuoteItems,
  oldQuoteItems,
}: createTemporaryQuoteItemProps) => {
  const previousQuoteItems = oldQuoteItems.filter(
    (quoteItem) => quoteItem.position < lineItemPosition,
  );
  const updatedPositionQuoteItems = oldQuoteItems
    .filter((quoteItem) => quoteItem.position >= lineItemPosition)
    .map((quoteItem, index: number) => ({
      ...quoteItem,
      position: lineItemPosition + index + newTempQuoteItems.length,
    }));
  return [
    ...previousQuoteItems,
    ...newTempQuoteItems,
    ...updatedPositionQuoteItems,
  ];
};

export const UPDATE_THICKNESS_ERROR_MESSAGES = {
  NON_VECTOR_FILES: {
    SINGLE: 'File must have .dwg or .dxf extension',
    MULTIPLE: 'All files must have .dwg or .dxf extension',
  },
  MULTIPLE_RESOURCE_CONNECTIONS: {
    SINGLE: 'File is connected to multiple resources',
    MULTIPLE: 'Some files are connected to multiple resources',
  },
};

export const isFileThicknessUpdateableForBulkAction = (
  files: QuoteFile[],
): { isUpdateable: boolean; errorMessage: string | null } => {
  let hasMultipleResourceConnections = false;
  let hasNonVectorFiles = false;

  for (const file of files) {
    if (!isFileVector(file.fileType)) {
      hasNonVectorFiles = true;
    }
    if (file.isConnectedToMultipleResources) {
      hasMultipleResourceConnections = true;
    }
  }

  const isMultiple = files.length > 1;

  return {
    isUpdateable: !hasNonVectorFiles && !hasMultipleResourceConnections,
    errorMessage: hasNonVectorFiles
      ? isMultiple
        ? UPDATE_THICKNESS_ERROR_MESSAGES.NON_VECTOR_FILES.MULTIPLE
        : UPDATE_THICKNESS_ERROR_MESSAGES.NON_VECTOR_FILES.SINGLE
      : hasMultipleResourceConnections
      ? isMultiple
        ? UPDATE_THICKNESS_ERROR_MESSAGES.MULTIPLE_RESOURCE_CONNECTIONS.MULTIPLE
        : UPDATE_THICKNESS_ERROR_MESSAGES.MULTIPLE_RESOURCE_CONNECTIONS.SINGLE
      : null,
  };
};
